<h2>Upload Claims</h2>
<section style="margin-top: 12px"> 
  <button class="inm-button" (click)="showDialog()">Upload Manual Claims</button>
</section>
<app-upload-manual-claim-dialog id="associateDocumentsDialog"
  [(show)]="showFileDialog" (uploadComplete)="uploadComplete($event)">
</app-upload-manual-claim-dialog>